import { render, staticRenderFns } from "./MfaIndexComponent.vue?vue&type=template&id=f2dfe992"
import script from "./MfaIndexComponent.vue?vue&type=script&lang=js"
export * from "./MfaIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports